// Known channel values for the Spam Rules / Flows / Feedback channel selectors.
//
// This MUST match @cxhub/shared's Channel enum (shared/src/canonical.js). It is
// duplicated here only because `ui` has no dependency on the shared workspace
// package, so the enum cannot be imported at build time.
//
// It is NOT a free-form label list. spam_rules.channel and flows.channel are
// matched by EXACT equality against a conversation's channel, so a value that
// drifts from the enum produces a rule that silently never fires — which reads
// as "spam filtering is broken" rather than as a naming mismatch.
//
// This list previously carried 'email' where the enum says 'm365_email',
// documented at the time as a deliberate mismatch that was out of scope. It
// stopped being out of scope the moment email became a real channel.
//
// server/test/channel-list-sync.test.js asserts this file and the enum agree,
// so the duplication can no longer drift silently.
export const KNOWN_CHANNELS = ['ebay', 'm365_email', 'chat', 'phone', 'sms', 'task']

// Human-readable labels for the SAME values. Separate from the list above on
// purpose: the list is matched against stored data and must stay exactly the
// enum, while these are display-only. Fall back to the raw value for anything
// unmapped rather than rendering blank.
//
// App.jsx kept its own copy of this map keyed on 'email' — the same stale name
// migration 0038 had to clean out of spam_rules/flows. There the mismatch made
// rules silently never fire; here it is only cosmetic (the agent's channel chip
// would read a raw 'm365_email'), and latent until email ingestion is switched
// on. One shared map so the next channel added cannot reintroduce the split.
export const CHANNEL_LABELS = {
  ebay: 'eBay',
  m365_email: 'Email',
  chat: 'Chat',
  phone: 'Phone',
  sms: 'SMS',
  task: 'Tasks',
}
